export default __webpack_public_path__ + "static/media/history.2edd2cb3.svg";